import * as React from "react";
import type { SVGProps } from "react";
const SvgCompass = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16.949 8.316a1 1 0 0 0-1.265-1.265l-6 2a1 1 0 0 0-.633.633l-2 6a1 1 0 0 0 1.265 1.265l6-2a1 1 0 0 0 .633-.633zM9.58 14.42l1.21-3.628 3.628-1.21-1.21 3.629z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20m7.937 9H19a1 1 0 1 0 0 2h.937A8 8 0 0 1 13 19.937V19a1 1 0 1 0-2 0v.937A8 8 0 0 1 4.063 13H5a1 1 0 1 0 0-2h-.937A8 8 0 0 1 11 4.063V5a1 1 0 1 0 2 0v-.937A8 8 0 0 1 19.937 11"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCompass;
